import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetPassword } from "../actions/userActions";
import Message from "../components/Message";
import Loader from "../components/Loader";
const ResetPassword = () => {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const { success, loading, error } = useSelector(
    (state) => state.resetPassword
  );

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
    if (!!errors[field])
      setErrors({
        ...errors,
        [field]: null,
      });
  };
  const dispatch = useDispatch();
  const { token } = useParams();

  const findFormErrors = () => {
    const { password, conf_password } = form;
    const newErrors = {};
    //password errors
    if (!password || password === "")
      newErrors.password = "this field is required";
    else if (password.length < 8)
      newErrors.password = "Minimum length for password is 8";
    if (!conf_password || conf_password === "")
      newErrors.conf_password = "this field is required";
    else if (password.length < 8)
      newErrors.password = "Minimum length for password is 8";
    else if (conf_password !== password)
      newErrors.conf_password = "Passwords must match";
    return newErrors;
  };

  const submitHandler = (e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    // Conditional logic:
    if (Object.keys(newErrors).length > 0) {
      // We got errors!
      setErrors(newErrors);
    } else {
      // No errors! Put any logic here for the form submission!
      let merchant = {
        password: form.password,
      };
      dispatch(resetPassword({ password: merchant.password, token }));
    }
  };
  return (
    <div>
      {loading && <Loader />}
      <section className="">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              {error && <Message variant="danger">{error}</Message>}
              {success && <Message variant="danger">{success}</Message>}
              <h2>Reset Your Password</h2>
              <form className="" onSubmit={submitHandler}>
                <div className="form-group">
                  <input
                    type="password"
                    className="form-control mb-0"
                    id="password"
                    name="password"
                    placeholder="New Password"
                    onChange={(e) => setField("password", e.target.value)}
                  />
                  <label htmlFor="password" className="error">
                    {errors.password && errors.password}
                  </label>
                </div>
                <div className="form-group">
                  <input
                    type="password"
                    className="form-control mb-0"
                    id="conf_password"
                    name="conf_password"
                    placeholder="Confirm Password"
                    onChange={(e) => setField("conf_password", e.target.value)}
                  />
                  <label htmlFor="conf_password" className="error">
                    {errors.conf_password && errors.conf_password}
                  </label>
                </div>

                <button
                  type="submit"
                  variant="danger"
                  className="btn btn-danger"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResetPassword;
